import { State } from '@cemex/cmx-client-layout';
import { InjectionToken } from '@angular/core';
import { ActionReducerMap, combineReducers, createFeatureSelector } from '@ngrx/store';
import * as fromProductTypeState from './product-type.reducer';
import * as fromShipmentLocationState from './shipment-location.reducer';
import * as fromSalesRegionState from './sales-regions.reducer';
import * as fromShippingConditionState from './shipping-condition.reducer';
import * as fromExperiencesState from './experiences.reducer';

export const multipleOrderModalKey = 'multipleOrderAccessModal';
export const reducers = {
  productType: fromProductTypeState.reducer,
  shipmentLocation: fromShipmentLocationState.reducer,
  shippingCondition: fromShippingConditionState.reducer,
  salesRegions: fromSalesRegionState.reducer,
  experiences:  fromExperiencesState.reducer,
};

export interface MultipleOrderOnlineFeatureState {
  productType: fromProductTypeState.ProductTypeState;
  shipmentLocation: fromShipmentLocationState.ShipmentLocationState;
  shippingCondition: fromShippingConditionState.ShippingConditionState;
  salesRegions: fromSalesRegionState.SalesRegionState;
  experiences: fromExperiencesState.ExperiencesState;
}

export interface MultipleOrderModalState extends State {
  multipleOrderModalState: MultipleOrderOnlineFeatureState;
}

export const reducerToken = new InjectionToken<ActionReducerMap<MultipleOrderModalState>>('COMBINED_REDUCERS');

export const reducerProvider = {
  provide: reducerToken,
  useFactory: () =>
    combineReducers({
      ...reducers,

    }),
};

export const getMultipleOrderModalState = createFeatureSelector<MultipleOrderOnlineFeatureState>(multipleOrderModalKey);
